import { IStatusConfigItem } from '../network/models/OrderTypes'
export const SENTRY_DSN =
  'https://168efdda115e425ebf8febbc96b89d25@front-monitor.xiaopeng.com/6'

export const ORDER_STATUE_CONFIG: IStatusConfigItem[] = [
  {
    status: 1,
    label: {
      mobile: '新派单',
      remote: '新派单',
    },
    labelType: {
      mobile: 'success',
      remote: 'success',
    },
    optList: {
      mobile: 'chargeback,receive',
      remote: 'cancel,confirm',
    },
  },
  {
    status: 2,
    label: {
      mobile: '已接单',
      remote: '已确认',
    },
    labelType: {
      mobile: 'primary',
      remote: 'primary',
    },
    optList: {
      mobile: 'chargeback,start',
      remote: 'arrival',
    },
  },
  {
    status: 3,
    label: {
      mobile: '订单待分派',
      remote: '',
    },
    labelType: {
      mobile: 'primary',
      remote: '',
    },
    optList: {
      mobile: 'chargeback,receive',
      remote: '',
    },
  },
  {
    status: 4,
    label: {
      mobile: '新派遣',
      remote: '',
    },
    labelType: {
      mobile: 'primary',
      remote: '',
    },
    optList: {
      mobile: 'chargeback,receive',
      remote: '',
    },
  },
  {
    status: 5,
    label: {
      mobile: '已出发',
      remote: '',
    },
    labelType: {
      mobile: 'primary',
      remote: '',
    },
    optList: {
      mobile: 'terminate,arrival',
      remote: '',
    },
  },

  {
    status: 6,
    label: {
      mobile: '已到达',
      remote: '客户已到达',
    },
    labelType: {
      mobile: 'primary',
      remote: 'primary',
    },
    optList: {
      mobile: 'terminate,lookaround',
      remote: 'terminate,lookaround',
    },
  },
  {
    status: 7,
    label: {
      mobile: '环车检查已完成',
      remote: '环车检查已完成',
    },
    labelType: {
      mobile: 'error',
      remote: 'error',
    },
    optList: {
      mobile: 'terminate',
      remote: 'terminate',
    },
  },
  {
    status: 8,
    label: {
      mobile: '施工中',
      remote: '施工中',
    },
    labelType: {
      mobile: 'warning',
      remote: 'warning',
    },
    optList: {
      mobile: 'finish',
      remote: 'finish',
    },
  },
  {
    status: 9,
    label: {
      mobile: '质检已完成',
      remote: '质检已完成',
    },
    labelType: {
      mobile: 'warning',
      remote: 'warning',
    },
    optList: {
      mobile: 'finish',
      remote: 'finish',
    },
  },
  {
    status: 10,
    label: {
      mobile: '结算中',
      remote: '结算中',
    },
    labelType: {
      mobile: 'warning',
      remote: 'warning',
    },
    optList: {
      mobile: 'finish',
      remote: 'finish',
    },
  },
  {
    status: 11,
    label: {
      mobile: '已结算',
      remote: '已结算',
    },
    labelType: {
      mobile: 'default',
      remote: 'default',
    },
    optList: {
      mobile: 'finish',
      remote: 'finish',
    },
  },
  {
    status: 12,
    label: {
      mobile: '服务完成',
      remote: '服务完成',
    },
    labelType: {
      mobile: 'default',
      remote: 'default',
    },
    optList: {
      mobile: '',
      remote: '',
    },
  },
  {
    status: 13,
    label: {
      mobile: '已终止',
      remote: '已终止',
    },
    labelType: {
      mobile: 'default',
      remote: 'default',
    },
    optList: {
      mobile: '',
      remote: '',
    },
  },
  {
    status: 14,
    label: {
      mobile: '已取消',
      remote: '已取消',
    },
    labelType: {
      mobile: 'default',
      remote: 'default',
    },
    optList: {
      mobile: '',
      remote: '',
    },
  },
]

export const OP_BTNS = {
  receive: '接单',
  chargeback: '退单',
  start: '出发',
  arrival: '到达',
  terminate: '提前结束',
  finish: '完成还车',
  lookaround: '环车检查',
  cancel: '取消预约',
  confirm: '确认预约'
}

export const MS_LIST_TABS = [
  {
    label: '今日工单',
    value: 'today',
  },
  {
    label: '待接工单',
    value: 'fresh',
  },
  {
    label: '进行中工单',
    value: 'processing',
  },
  {
    label: '全部工单',
    value: 'all',
  },
]
